import React, { useState } from 'react';
import authService from '../services/authService';
import Button from './ui/Button';
import './Login.css';
import './AuthPages.css';

/**
 * Página "Esqueci minha senha" — rota /forgot-password.
 *
 * O app não usa React Router: App.jsx detecta o pathname e renderiza
 * esta página. Acessível sem login.
 *
 * Envia o e-mail para POST /auth/forgot-password. A resposta do backend
 * é sempre genérica (anti-enumeração de contas), então mostramos uma
 * mensagem de sucesso genérica independentemente de o e-mail existir.
 */
function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await authService.forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err.message || 'Não foi possível enviar o link. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page-wrapper">
      <div className="login-form-column auth-card">
        <div className="login-form-header">
          <h2 className="form-title">Esqueceu sua senha?</h2>
          <p className="form-subtitle">
            Informe o e-mail da sua conta. Se ele estiver cadastrado,
            enviaremos um link para você redefinir a senha.
          </p>
        </div>

        {sent ? (
          <>
            <div className="success-message">
              Se o e-mail informado estiver cadastrado, enviamos um link de
              redefinição. Verifique sua caixa de entrada (e a pasta de spam).
              O link expira em 1 hora.
            </div>
            <div className="auth-back">
              <a href="/" className="forgot-link">← Voltar ao login</a>
            </div>
          </>
        ) : (
          <form onSubmit={handleSubmit} className="login-form-main">
            <div className="form-group">
              <label className="form-label">E-mail Corporativo</label>
              <div className="input-wrapper">
                <span className="material-symbols-outlined input-icon">mail</span>
                <input
                  type="email"
                  className="form-input"
                  placeholder="nome@empresa.com.br"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>
            </div>

            {error && <div className="error-message">{error}</div>}

            <Button type="submit" className="submit-btn" disabled={loading}>
              {loading ? 'ENVIANDO...' : 'ENVIAR LINK'}
              <span className="material-symbols-outlined" style={{ marginLeft: '0.5rem' }}>arrow_forward</span>
            </Button>

            <div className="auth-back">
              <a href="/" className="forgot-link">← Voltar ao login</a>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;
